import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    adminData: [],
    loading: false,
    error: null,
    Active: null,
    pagination: {},
    createAdminSucceeded: false
}

export const adminSlice = createSlice({
    name: 'admin',
    initialState: {
        adminData: [],
        loading: false,
        error: null,
        Active: null,
        pagination: {},
        createAdminSucceeded: false,
        isActiveSuccess : null,
        isDeleteSuccess : null,
        
        
        
    },
    initialState,
    reducers: {
        createAdminLoad: (state) => {
            state.loading = true;
            state.createAdminSucceeded = false

        },
        createAdminSuccess: (state) => {
            state.loading = false;
            state.createAdminSucceeded = true
        },
        createAdminFail: (state) => {
            state.loading = false;
            state.error = false;
            state.createAdminSucceeded = false
        },
        adminListLoad: (state) => {
            state.loading = true;
        },
        adminListSuccess: (state, action) => {
            console.log(action.payload.data, "this is my payload");
            state.loading = true;
            state.adminData = action.payload.data.list;
            state.pagination = action.payload.data.pagination;
        },
        adminListFailed: (state) => {
            state.loading = false;

        },
        activeAdminLoad: (state) => {
            state.loading = true;
            state.isActiveSuccess = false
        },

        activeAdminSuccess: (state) => {
            state.loading = false;
            state.isActiveSuccess = true;
        },
        deleteAdminLoad: (state) => {
            state.loading = true;
            state.isDeleteSuccess = false;
        },
        deleteAdminSuccess: (state) => {
            state.loading = false;
            state.isDeleteSuccess = true;

        }
         },
       
});

export const { createAdminLoad, createAdminFail, createAdminSuccess, adminListLoad, adminListFailed, adminListSuccess, activeAdminLoad, activeAdminSuccess, deleteAdminLoad, deleteAdminSuccess } = adminSlice.actions;
export default adminSlice.reducer;